// extracted by mini-css-extract-plugin
module.exports = {"aboutText":"about-module--about-text--2PHWj"};